import { render, staticRenderFns } from "./UniversityAvatar.vue?vue&type=template&id=27421052&scoped=true&"
import script from "./UniversityAvatar.vue?vue&type=script&lang=js&"
export * from "./UniversityAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UniversityAvatar.vue?vue&type=style&index=0&id=27421052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27421052",
  null
  
)

export default component.exports